import { render, staticRenderFns } from "./NonClinicalAppointmentsGrid.vue?vue&type=template&id=5434a245&"
import script from "./NonClinicalAppointmentsGrid.vue?vue&type=script&lang=js&"
export * from "./NonClinicalAppointmentsGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports